var render = function render(){var _vm=this,_c=_vm._self._c;return _c('home-base-rail',{attrs:{"label":_vm.label,"variant":"ranking"}},_vm._l((_vm.items),function(project){return _c('home-ranking-card',{key:project.id,attrs:{"project":project,"show-views":_vm.showViews}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }